<div class=" asset profile-authentication-area ptb-100">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-md-12" style="margin-bottom:12px">
                <!-- <div class="login-form"> -->
                <img src="assets/img/picturecfa.jpeg
                    ">

            </div>
            <div class="col-lg-6 col-md-12">
                <div *ngIf="disableRegistration" class="login-form">
                    <h2 style="color: #9b215c;">Les pré-inscriptions sont terminées pour l'année 2022-2023</h2>
                    <p>Veuillez nous contacter pour avoir plus d'informations de la rentrée 2023-2024</p>
                </div>
                <div *ngIf="!disableRegistration" class="login-form">
                    <h2 class="level-title">Formulaire de pré-inscription</h2>
                    <div class="redmessage"
                    *ngIf="(submitted && registrationForm.invalid) || hasError">
                    {{errorMessage}}
                </div>
                <div class="greenmessage"  *ngIf="message">
                    <strong> {{message}}</strong>
<div>Nous avons bien reçu votre demande et nous vous remercions de votre intérêt.
Une fois votre préinscription validée, vous recevrez un e-mail de confirmation.
Nous restons à votre disposition pour toute question ou information complémentaire.</div>
                </div>
                    <div *ngIf="currentStep === 1">
                        <form [formGroup]="registrationForm.get('step1')" (ngSubmit)="next()">

                            <div class="form-group">
                                <label>Nom(s)</label>
                                <input
                                    [ngClass]="{ 'is-invalid': submitSteps.step1 && registrationForm.get('step1.name').errors }"
                                    name="name" formControlName="name" type="text" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Prénom(s)</label>
                                <input
                                    [ngClass]="{ 'is-invalid': submitSteps.step1 && registrationForm.get('step1.firstname').errors }"
                                    formControlName="firstname" name="firstName" type="text" class="form-control">
                            </div>

                            <div class="form-group">
                                <label>Adresse Email</label>
                                <input
                                    [ngClass]="{ 'is-invalid': submitSteps.step1 && registrationForm.get('step1.email').errors }"
                                    formControlName="email" name="email" type="text" class="form-control">
                            </div>
                            <div class="row align-items-center">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-6 lost-your-password-wrap">

                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-6 lost-your-password-wrap">
                                    <button class="btn btn-success" type="submit" (click)="next()">
                                        Suivant</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div *ngIf="currentStep== 2">
                        <form [formGroup]="registrationForm.get('step2')" (ngSubmit)="next()">

                            <div class=" ordering">
                                <div class="select-box">
                                    <label>Pays</label>
                                    <select class="form-control" formControlName="country">
                                        <option *ngFor="let item of countries" [ngValue]="item">{{item.name}}
                                        </option>
                                    </select>
                                </div>

                            </div>
                            <div style="margin-top:40px" class="form-group">
                                <label>Numéro WhatsApp</label>
                                <div class="input-group">
                                    <span class="input-group-text">{{
                                        registrationForm?.get('step2').value.country.code
                                        }}</span>
                                    <input
                                        [ngClass]="{ 'is-invalid': submitSteps.step2 && (registrationForm.get('step2').value.phone.length == 0 || !registrationForm.get('step2').value.phone.valid  ) }"
                                        [placeholder]="registrationForm.get('step2').value.country.code" id="telephone"
                                        formControlName="phone" type="tel"
                                        [textMask]="{mask: registrationForm.get('step2').value.country.phone_mask}"
                                        class="form-control">

                                </div>
                            </div>

                            <div class="row align-items-center">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-6 lost-your-password-wrap">
                                    <button [disabled]="showSpinner" type="button" class="btn btn-success"
                                        (click)="previous()">
                                        Précédent</button>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-6  lost-your-password-wrap">
                                    <button class="btn btn-success" (click)="next()">
                                        Suivant</button>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div *ngIf="currentStep == 3">
                        <form [formGroup]="registrationForm.get('step3')" (ngSubmit)="onSubmitRegistration()">

                             <!-- <div class=" ordering">
                                <div class="select-box">
                                    <label>Niveau de classe</label>
                                    <select class="form-control" formControlName="level">
                                        <option checked value="1" [ngValue]="'1'">1ère année</option>
                                        <option value="2" [ngValue]="'2'">2ième année</option>
                                    </select>
                                </div>
                            </div>  -->
                            <div class=" ordering">
                                <div class="select-box" style="margin-top:40px">
                                    <label>Pour quelle(s) raison(s) souhaitez-vous intégrer le CFA ?</label>
                                    <select class="form-control" formControlName="reason">
                                        <option checked value="Obligation envers quelqu'un ou un groupe"
                                            [ngValue]="obligation">Obligation envers quelqu'un ou un groupe</option>
                                        <option value="Démarche personnelle et spirituelle"
                                            [ngValue]="'Démarche personnelle et spirituelle'">Démarche personnelle et
                                            spirituelle</option>
                                        <option checked value="Aucune, juste par curiosité"
                                            [ngValue]="'Aucune, juste par curiosité'">Aucune, juste par curiosité
                                        </option>
                                    </select>
                                </div>

                            </div>

                          
                            <div style="margin-top:40px">En cliquant sur <strong>Envoyer</strong>, vous acceptez
                                nos
                                <a [routerLink]="'/terms-of-service'">Conditions générales d'utilisations</a>. Découvrez
                                comment nous
                                recueillons, utilisons vos données en lisant notre Politique d’utilisation des données
                                et
                                comment nous utilisons les cookies et autres technologies similaires.
                            </div>

                            <div class="row align-items-center">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-6  lost-your-password-wrap">
                                    <button [disabled]="showSpinner" type="button" class="btn btn-success"
                                        (click)="previous()">
                                        Précédent</button>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-6 lost-your-password-wrap">

                                    <button type="submit"
                                        [disabled]="showSpinner || !registrationForm.get('step3').valid"
                                        class="btn btn-success" type="submit"> Envoyer <span *ngIf="showSpinner"
                                            class="spinner-border spinner"></span></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>